import React, { useState } from "react";
import CompanyDetails from "../molecules/CompanyDetails";
import ContentContainer from "../atoms/ContentContainer";
import FormTitle from "../atoms/FormTitle";
import ExplanationText from "../atoms/ExplanationText";
import InputWrapper from "../atoms/InputWrapper";
import InputItem from "../atoms/InputItem";
import Dossier from "../atoms/icons/Dossier";
import CurrentSessionInfoField from "../atoms/CurrentSessionInfoField";
import ArrowRight from "../atoms/icons/ArrowRight";
import InputCheckbox from "../atoms/InputCheckbox";
import ChamberOfCommerceSearchModal from "./ChamberOfCommerceSearchModal";
const CompanyInformationStep = ({ onChange: handleChange, onSubmit: handleSubmit, data, user, errors, loading, companyInformationLoading, setPreviousStep, index, patch, }) => {
    const [showModal, setShowModal] = useState(false);
    function updateFormFields(item) {
        const address = item.addresses[0] || null;
        patch({
            company_kvk_number: item.kvk_number,
            company_name: item.name,
            company_street: address ? address.street : "",
            company_house_number: address ? address.house_number : "",
            company_house_number_addition: address
                ? address.house_number_addition
                : "",
            company_postal_code: address ? address.postal_code : "",
            company_city: address ? address.city : "",
            company_phone_number: "",
            company_email: "",
            company_income_tax_number: "",
        });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(ChamberOfCommerceSearchModal, { showModal: showModal, onClose: () => setShowModal(false), onSelect: updateFormFields }),
        React.createElement("form", { onSubmit: handleSubmit },
            React.createElement(ContentContainer, { hasMandatoryExplanationText: true, backButtonHandle: setPreviousStep, hasFooterActions: true, nextButtonText: "Volgende stap", hasNextButtonIconRight: true, nextButtonIcon: React.createElement(ArrowRight, null), loading: loading },
                React.createElement(FormTitle, null, "Bedrijfsgegevens"),
                React.createElement(ExplanationText, null, "Onderstaand treft u de gegevens die bij ons bekend zijn. Indien deze niet correct of volledig zijn vragen wij u deze te corrigeren en/of aan te vullen."),
                React.createElement(CurrentSessionInfoField, { icon: React.createElement(Dossier, null), label: "Dossiernummer" }, user.doswerk_dossier),
                React.createElement(InputWrapper, null,
                    React.createElement(InputItem, { loading: companyInformationLoading, type: "text", error: errors.company_kvk_number, name: "company_kvk_number", autoComplete: "none", pattern: "\\d+", label: "KVK-nummer", value: data.company_kvk_number, onChange: handleChange, disabled: loading, hasSearchButton: true, onClick: (e) => {
                            e.preventDefault();
                            setShowModal(true);
                        } })),
                React.createElement(InputWrapper, null,
                    React.createElement(InputItem, { required: true, type: "text", error: errors.company_name, name: "company_name", label: "Naam", value: data.company_name, onChange: handleChange, disabled: loading })),
                React.createElement(CompanyDetails, { data: data, errors: errors, onChangeHandler: handleChange, fieldNamePrefix: "company_", companyName: data.company_name, chamberOfCommerceNumber: data.company_kvk_number, loading: loading }),
                React.createElement(InputCheckbox, { name: "company_acknowledgement", onChange: handleChange, label: "Ik verklaar hierbij dat de bovenstaande gegevens correct zijn ingevoerd", checked: data.company_acknowledgement, required: true, disabled: loading })))));
};
export default CompanyInformationStep;
